<p-dialog header="Nhật ký truyền nhận dữ liệu" [(visible)]="display" [style]="{width: '900px'}" [resizable]="false" position="top">
  <div class="p-grid alert alert-info p-pt-2" *ngIf="agreement">
    <div class="p-col-3" *ngIf="agreement['agreementNo']">
      <span>{{ 'InvoiceNo'|translate }}: <b>{{ agreement['agreementNo'] }}</b></span>
    </div>
    <div class="p-col-3" *ngIf="agreement['agreementDate']">
      <span>Ngày lập: <b>{{ agreement['agreementDate']|date:'dd/MM/yyyy' }}</b></span>
    </div>
  </div>
  <div class="iam-scroll" [style]="{width: '100%', maxHeight: '400px', overflow: 'hidden auto'}">
    <div class="p-grid" *ngFor="let log of tVanLogs" style="border-bottom: 1px solid #ccc;">
      <div class="p-col-9">
        <div class="p-col-12">
          {{ log['messageDate']|date:'dd/MM/yyyy HH:mm:ss' }}
        </div>
        <div class="p-col-12">
          [{{ log['messageCode'] }}] {{ log['messageDescription'] }}
        </div>
        <div class="p-col-12" *ngIf="log['errors']" [ngClass]="{'alert-primary': log['statusId'] === 'SmsgSent', 'alert-warning': log['statusId'] === 'SmsgFailed', 'alert-danger': log['statusId'] === 'SmsgError'}">
          <div class="alert" *ngFor="let error of log['errors']">
            ({{ error['lastUpdatedStamp']|date:'dd/MM/yyyy HH:mm:ss' }}) [{{ error['errorCode'] }}] {{ error['errorText'] }}
          </div>
        </div>
        <div class="p-col-12" *ngIf="log['docControl']">
          <span>Số thông báo: {{ log['docControl'] }}</span>
        </div>
        <div class="p-col-12">
          <span style="color: #8e9195">Mã thông điệp: {{ log['messageId'] }}</span>
        </div>
      </div>
      <div class="p-col-3">
        <div class="p-col-12 p-text-right">
          <b *ngIf="log['senderId'] === 'TCT'">Cơ quan thuế</b>
          <b *ngIf="log['senderId'] !== 'TCT'">{{ log['senderId'] }}</b>
        </div>
        <div class="p-col-12 p-text-center">
          <div class="alert" [ngClass]="{'alert-primary': log['statusId'] === 'SmsgSent', 'alert-warning': log['statusId'] === 'SmsgFailed', 'alert-danger': log['statusId'] === 'SmsgError'}">{{ log['status'] }}</div>
        </div>
        <div class="p-col-12 p-text-right">
          <p-button icon="pi pi-download" styleClass="p-button-rounded p-button-secondary p-button-outlined p-button-sm"
                    (onClick)="downloadXml(log)" title="{{ 'Download+Xml'|translate }}"></p-button>
        </div>
      </div>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="display=0"></p-button>
  </p-footer>
</p-dialog>
